<div class="action-wrapper">

  @if(params.showDocuments){
  <button
    class="btn btn-sm btn-outline-primary"
    (click)="documents()">
    <i class="bi bi-folder2-open"></i>
    Documents
  </button>
}

  @if(params.showEdit){
    <i
      class="bi bi-pencil-square global-edit-icon"
      (click)="edit()">
    </i>
  }

  @if(params.showHistory){

    @if(params.showEdit){
      <span class="divider">|</span>
    }

    <i
      class="bi bi-clock-history global-edit-icon"
      (click)="history()">
    </i>
  }

  @if(params.showToggle){

    @if(params.showEdit || params.showHistory){
      <span class="divider">|</span>
    }

    <label class="global-switch">
      <input
        type="checkbox"
        [checked]="checked"
        (change)="toggle($event)">
      <span class="global-slider"></span>
    </label>

  }

  @if(params.showDownload){

    @if(params.showEdit || params.showHistory || params.showToggle){
      <span class="divider">|</span>
    }

    <i
      class="bi bi-download global-edit-icon"
      (click)="download()">
    </i>

  }

  @if(params.showView){

    @if(params.showDownload){
      <span class="divider">|</span>
    }

    <i
      class="bi bi-eye-fill text-primary"
      style="cursor:pointer;font-size:16px"
      (click)="view()">
    </i>

  }

  @if(params.showCancel){

    @if(params.showView){
      <span class="divider">|</span>
    }

    <i
      class="bi bi-x-circle-fill action_style"
      style="cursor:pointer"
      (click)="cancel()">
    </i>

  }




</div>